import api from './api';

export interface AudienceSegment {
  ID: string;
  Label: string;
}

// Get Audience Segments
// GET /api/segments
// Response: { segments: Array<AudienceSegment> }
export const getAudienceSegments = async (): Promise<{ segments: AudienceSegment[] }> => {
  try {
    console.log('Fetching audience segments');
    const response = await api.get('/api/segments');
    console.log(`Successfully fetched ${response.data.segments.length} audience segments`);
    return response.data;
  } catch (error) {
    console.error('Error fetching audience segments:', error);
    throw new Error(error?.response?.data?.error || 'Failed to fetch audience segments');
  }
};